//@flow

// Vendors
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { goBack, push } from 'connected-react-router';

// Actions

// Components
import { FormActions, Trans, Loading } from '../../../components';
import { LinkingGuidanceModal } from '../../../components/common/modals';
import { ButtonPrimary, Button } from 'texkit/dist/components/Buttons';

// Helpers
import { selectAgencyLink } from '../../../reducers/agency/agencySelectors';
import useRedirect from '../../../hooks/useRedirect';
import { openModal } from '../../../reducers/modal/modalActions';

const LinkServiceIneligible = () => {
  const link = useSelector(selectAgencyLink);
  useRedirect(!link, '/link');
  const dispatch = useDispatch();
  if (!link) return <Loading />;

  const { app, agency } = link;

  return (
    <>
      <h1 className="h2">
        <Trans
          file={agency.agencySlug}
          id={`${app.appSlug}_LinkService_IneligibleRegistration`}
        />
      </h1>
      <p>
        <Trans
          file={agency.agencySlug}
          id={`${app.appSlug}_LinkService_DescriptionIneligibleRegistration`}
        />
      </p>
      <a
        className="linking-guidance-text"
        onClick={() => dispatch(openModal('LinkingGuidanceModal'))}
      >
        <Trans
          file={agency.agencySlug}
          id={`${app.appSlug}_LinkService_LookupVehicleLinkReq`}
        />
      </a>

      <FormActions>
        <div className="form-actions-item service-inegible-link-another">
          <ButtonPrimary onClick={() => dispatch(push('/dashboard'))}>
            <Trans file="Labels" id="ViewMyDashboard" />
          </ButtonPrimary>
        </div>
        <div className="form-actions-item service-inegible-link-another">
          <Button className="Button" onClick={() => dispatch(goBack())}>
            <Trans
              file={agency.agencySlug}
              id={`${app.appSlug}_Label_LinkAnother`}
            />
          </Button>
        </div>
      </FormActions>
      <LinkingGuidanceModal />
    </>
  );
};

export default LinkServiceIneligible;
